import template from "@stackhouse/dashboard-components/utils/template"
import { generatePath } from '@stackhouse/dashboard-components/Dashboard'

import Export from '../modals/export'


export const makeCreate = ({ createPath, createInitialData }) => function () {
    const { match: { params } } = this.props
    const initialData = createInitialData instanceof Function ? createInitialData(params) : createInitialData
    return this.props.history.push({
        pathname: generatePath(createPath, params),
        state: { /*onSave: this.loadData,*/ data: initialData || {} }
    })
}


export const makeDelete = ({ deleteEndpoint }) => function () {
    (function () {
        if (this.gridRef.current) {
            const { results: { elements, elementCount } } = this.state
            const selectedRow = this.gridRef.current.getSelectedRow()

            if (selectedRow) {
                const { rowIndex, row } = selectedRow
                const { client, withLoader } = this.props

                return withLoader(done => {
                    return client.delete(template(deleteEndpoint, row)).then(() => {
                        return this.setState({
                            results: {
                                elementCount: elementCount - 1,
                                elements: [...elements.slice(0, rowIndex), ...elements.slice(rowIndex + 1)]
                            }
                        })
                    }).then(done).catch(done)
                })
            }
        }
    }).apply(this.filterRef.current)
}

export const makeExport = ({ exportEndpoint }) => function () {
    return Export({
        allowPDFConversion: false,
        endpoint: exportEndpoint,
        requestData: { filters: this.filterRef.current.getFilter() }
    })
}


const DefaultFilterGridActions = ({ createPath, createInitialData, deleteEndpoint, exportEndpoint } = {}) => [
    {
        id: 'new',
        title: 'New',
        icon: 'add_circle',
        container: 'navbar.left',
        onClick: makeCreate({ createPath, createInitialData }),
    },
    {
        id: 'delete',
        title: 'Delete',
        icon: 'delete_forever',
        container: 'navbar.left',
        onClick: makeDelete({ deleteEndpoint }),
    },
    {
        id: 'export',
        title: 'Export',
        icon: 'assignment',
        container: 'navbar.right',
        onClick: makeExport({ exportEndpoint }),
    }
]


export default DefaultFilterGridActions

